import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import EquipmentForm, {
  EquipmentFormFields,
} from '../../components/Equipment/EquipmentForm';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';

interface EquipmentsEditProps {
  id: number;
  customerId: number;
  setIsOpenModal: (isOpen: boolean) => void;
}

export default function EquipmentsEdit({
  id,
  customerId,
  setIsOpenModal,
}: EquipmentsEditProps) {
  const {
    user: { organization },
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [formFields, setFormFields] = useState<EquipmentFormFields>(
    null as unknown as EquipmentFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  async function getEquipment() {
    try {
      setIsLoading(true);
      if (organization && id) {
        const { data } = await api.get(
          `organizations/${organization.id}/customers/${customerId}/equipments/${id}`
        );

        setFormFields({
          name: data.name,
          brand: data.brand,
          model: data.model,
          serialNumber: data.serialNumber,
          description: data.description,
        });
      }
    } catch (e) {
      toast.error('Ocorreu um erro ao buscar o equipamento. Tente novamente');
    } finally {
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: EquipmentFormFields) => {
    try {
      await api.put(
        `organizations/${organization.id}/customers/${customerId}/equipments/${id}`,
        data
      );
      toast.success('Equipamento alterado com sucesso');
      setIsOpenModal(false);
    } catch (e: any) {
      if (e?.response?.data?.errors) {
        if (e?.response?.status === 422) {
          setFormErrors(e.response.data.errors);
        } else {
          toast.error(
            e?.response?.data?.errors.reduce(
              (acc: string, error: string) => acc + error,
              ''
            )
          );
        }
      } else {
        throw e;
      }
    }
  };

  useEffect(() => {
    getEquipment();
  }, [organization, id]);

  return isLoading ? (
    <div className='d-flex justify-content-center'>
      <div className='spinner-border' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  ) : (
    <EquipmentForm
      isLoading={isLoading}
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
